module.exports = __webpack_public_path__ + "98b0f6baa42c16506b582350608310da.jpg";